module.exports = __webpack_public_path__ + "26f7b4b7.png";